import { compose } from 'recompose';

import FileItem from './fileItem';

const enhance = compose();
export default enhance(FileItem);
